import { render, staticRenderFns } from "./FileHistory.vue?vue&type=template&id=a969e340&scoped=true&"
import script from "./FileHistory.vue?vue&type=script&lang=js&"
export * from "./FileHistory.vue?vue&type=script&lang=js&"
import style0 from "./FileHistory.vue?vue&type=style&index=0&id=a969e340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a969e340",
  null
  
)

export default component.exports